import type { FieldErrors } from '../../lib/validate';

/** The errors under `base`, re-keyed relative to it (`base` itself becomes ''), for components that take relative paths. */
export function relErrors(errors: FieldErrors, base: string): FieldErrors {
  const out: FieldErrors = {};
  for (const [k, v] of Object.entries(errors)) {
    if (k === base) out[''] = v;
    else if (k.startsWith(`${base}.`)) out[k.slice(base.length + 1)] = v;
  }
  return out;
}
